/* eslint-disable no-irregular-whitespace */
import NewsletterBox from "../StoryPage/NewsletterBox";
import Title from "../SmallComponents/Title";
import images from "../../assets/images/assets";

const ContactSection = () => {
  const handleExploreMaps = () => {
    const mapsUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d990.4985122241595!2d39.230752878258514!3d-6.770577056061502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c4f61145c1a0f%3A0xbf1edaa4be13258a!2sItsallaboutcards!5e0!3m2!1sen!2stz!4v1743071908293!5m2!1sen!2stz`;

    window.open(mapsUrl, "_blank"); // Open in a new tab
  };

  return (
    <div>
      <div className="text-center text-2xl pt-10">
        <Title text1={"Contact"} text2={"Us"} />
      </div>

      <div className="my-10 flex flex-col justify-center md:items-center lg:flex-row gap-10 mb-40">
        {/* Contact-Image */}
        <div className="map w-full md:max-w-[480px] bg-zinc-300 min-h-[350px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d990.4985122241595!2d39.230752878258514!3d-6.770577056061502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c4f61145c1a0f%3A0xbf1edaa4be13258a!2sItsallaboutcards!5e0!3m2!1sen!2stz!4v1743071908293!5m2!1sen!2stz" // Replace with the copied URL
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="flex flex-col justify-center items-start gap-6 ">
          <p className="font-semibold text-xl text-gray-600 ">Our Store</p>
          <p className="text-gray-500 montserrat">
            543708 <br /> Block 1101, Opposite TRA, Dar Es Salaam, Tanzania
          </p>
          <p className="text-gray-500 montserrat">
            Tel: (255) 717 314 009 <br /> Email: admin@itsallaboutcards.com
          </p>

          <p className="font-semibold text-xl text-gray-600 -mb-4">
            Open Hours
          </p>
          <p className="text-gray-500 montserrat">
            Monday-Friday, 8 am–8 pm <br /> Weekends, 8 am–5 pm
          </p>
          <p className="font-semibold text-xl text-gray-600">
            More Information
          </p>
          <p className="text-gray-500 montserrat">
            Learn more about our location on Google Maps.
          </p>
          <button
            className="bg-black text-white font-light px-8 py-4 mt-4 rounded-full hover:border-2 hover:border-zinc-50 hover:bg-blue-600  transition2 centered-row gap-2"
            onClick={handleExploreMaps}
          >
            <span> Explore On Maps</span>{" "}
            <img src={images.maps} alt="maps-icon" className="w-7" />
          </button>
        </div>
      </div>

      <NewsletterBox />
    </div>
  );
};

export default ContactSection;
